import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './LoginPage.css'
import { saveAuth } from '../../utils/auth'




const LOGO_URL = 'https://res.cloudinary.com/dk50cmtps/image/upload/v1786338929/unnamed_efi40j.png'
const LOGO_SIDE_IMG_URL = 'https://res.cloudinary.com/dk50cmtps/image/upload/v1786336638/592f1aee-a328-4135-bd3f-8a1e20477346_smm1fr.png'

const API_BASE_URL = 'https://upskld.co/api'


const loginSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email('Enter a valid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
})


const Login = () => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      remember: false,
    },
    validationSchema: loginSchema,

    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true)
      try {
        const response = await axios.post(`${API_BASE_URL}/login`, {
          email: values.email,
          password: values.password,
        })
if (response.data.success) {
  toast.success(response.data.message || 'Login successful!')

  saveAuth(response.data.token, response.data.user, values.remember)

  resetForm()
  setTimeout(() => {
    navigate('/home')
  }, 1200)
}
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          'Something went wrong. Please try again.'
        toast.error(errorMessage)
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  const goToRegister = (e) => {
    e.preventDefault()
    navigate('/register')
  }

  const goToForgotPassword = (e) => {
    e.preventDefault()
    navigate('/forgot-password')
  }
  useEffect(() => {
    document.querySelector('#root')?.scrollIntoView({ behavior: 'smooth' })
  }, [])
  return (
    <div className="login_pg_container">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="login_pg_left">
        <div className="login_pg_logo_row">
          <img
            src={LOGO_SIDE_IMG_URL}
            alt="login"
            className="login_pg_logo_side_img"
            width="48"
            height="48"
          />
          <img
            src={LOGO_URL}
            alt="Rubicr"
            className="login_pg_logo_img"
            width="56"
            height="56"
          />
        </div>
      </div>

      <div className="login_pg_right">
        <div className="login_pg_form_wrap">
          <h2 className="login_pg_title">Welcome back</h2>
          <p className="login_pg_subtitle">Log in to your  account to continue</p>

          <form className="login_pg_form" onSubmit={formik.handleSubmit} noValidate>
            <div className="login_pg_field">
              <label className="login_pg_label" htmlFor="email">
                Email Address <span className="login_pg_required">*</span>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                className="login_pg_input"
                placeholder="Enter your email address"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email && (
                <span className="login_pg_error_text">{formik.errors.email}</span>
              )}
            </div>

            <div className="login_pg_field">
              <label className="login_pg_label" htmlFor="password">
                Password <span className="login_pg_required">*</span>
              </label>
              <div className="login_pg_password_wrap">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  className="login_pg_input login_pg_input_password"
                  placeholder="Enter your password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  className="login_pg_eye_btn"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  tabIndex={-1}
                >
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-10-8-10-8a18.6 18.6 0 0 1 4.22-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 8 10 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s3-8 11-8 11 8 11 8-3 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
              {formik.touched.password && formik.errors.password && (
                <span className="login_pg_error_text">{formik.errors.password}</span>
              )}
            </div>

            <div className="login_pg_options_row">
              <div className="login_pg_checkbox_row">
                <input
                  id="remember"
                  name="remember"
                  type="checkbox"
                  className="login_pg_checkbox"
                  checked={formik.values.remember}
                  onChange={formik.handleChange}
                />
                <label htmlFor="remember" className="login_pg_checkbox_label">
                  Remember me
                </label>
              </div>
              <a href="/forgot-password" className="login_pg_forgot_link" onClick={goToForgotPassword}>
                Forgot password?
              </a>
            </div>

            <button type="submit" className="login_pg_submit_btn" disabled={isSubmitting}>
              {isSubmitting ? 'Please wait...' : (
                <>
                  Log In <span className="login_pg_arrow">&rarr;</span>
                </>
              )}
            </button>

            <p className="login_pg_signup_text">
              Don&apos;t have an account?{' '}
              <a href="/register" className="login_pg_signup_link" onClick={goToRegister}>
                Create one
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login